import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  accountEmailById,
  avatarUrlById,
  fullNameById,
} from '/redux/selector/client.selector';

import Header from './Header';

export default connect(
  createStructuredSelector({
    fullName: fullNameById,
    avatarUrl: avatarUrlById,
    accountEmail: accountEmailById,
  }),
)(Header);
